import React, { useEffect, useState } from "react";
import {
    GroupIcon,
    MailIcon,
} from "../../icons";
import { API_BASE_URL } from "../../utilities/constants";
import { handleApiCall } from "../../utilities/helper";
import { FaRegAddressBook, FaRegClock, FaRegStopCircle, FaRegUserCircle, FaUserPlus, FaWhatsapp } from "react-icons/fa";

const Cards = () => {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState({});
    const [controller, setController] = useState(null);

    const callListApi = async () => {
        controller?.abort();
        const newController = new AbortController();
        setController(newController);
        const { signal } = newController;
        setLoading(true);
        try {

            const response = await handleApiCall(
                `${API_BASE_URL}/api/backoffice/insidercircle/analytics`,
                {
                    method: "GET"
                },
                null,
                signal
            );
            if (response.responseStatus == true) {
                setData(response.data);
            } else {
                setData(null);
            }
            if (response.responseCode !== 299) {
                setLoading(false);
            }
        } catch (e) {
            console.error("Error", e);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        callListApi();
    }, []);

    return (
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-3 md:gap-6">
            <div className="rounded-xl border border-gray-200 bg-white dark:border-gray-800 dark:bg-white/[0.03] md:p-5">
                <div className="flex items-center justify-center w-10 h-10 bg-gray-100 rounded-lg dark:bg-gray-800">
                    <FaRegUserCircle className="text-gray-800 size-5 dark:text-white/90" />
                </div>

                <h4 className="mt-2 font-semibold text-gray-800 text-lg dark:text-white/90">
                    Total Insiders: {data?.totalInsiders ?? '-'}
                </h4>
                <div className="flex justify-between mt-2 text-xs text-gray-600 dark:text-gray-300"></div>
            </div>
            <div className="rounded-xl border border-gray-200 bg-white dark:border-gray-800 dark:bg-white/[0.03] md:p-5">
                <div className="flex items-center justify-center w-10 h-10 bg-gray-100 rounded-lg dark:bg-gray-800">
                    <FaRegClock className="text-gray-800 size-5 dark:text-white/90" />
                </div>

                <h4 className="mt-2 font-semibold text-gray-800 text-lg dark:text-white/90">
                    Quiz Started: {data?.quizStarted ?? '-'}
                </h4>
                <div className="flex justify-between mt-2 text-xs text-gray-600 dark:text-gray-300"></div>
            </div>
            <div className="rounded-xl border border-gray-200 bg-white dark:border-gray-800 dark:bg-white/[0.03] md:p-5">
                <div className="flex items-center justify-center w-10 h-10 bg-gray-100 rounded-lg dark:bg-gray-800">
                    <FaRegStopCircle className="text-gray-800 size-5 dark:text-white/90" />
                </div>

                <h4 className="mt-2 font-semibold text-gray-800 text-lg dark:text-white/90">
                    Quiz Completed: {data?.quizCompleted ?? '-'}
                </h4>
                <div className="flex justify-between mt-2 text-xs text-gray-600 dark:text-gray-300"></div>
            </div>
            <div className="rounded-xl border border-gray-200 bg-white dark:border-gray-800 dark:bg-white/[0.03] md:p-5">
                <div className="flex items-center justify-center w-10 h-10 bg-gray-100 rounded-lg dark:bg-gray-800">
                    <FaRegAddressBook className="text-gray-800 size-5 dark:text-white/90" />
                </div>

                <h4 className="mt-2 font-semibold text-gray-800 text-lg dark:text-white/90">
                    Referral: {data?.referralSignups ?? '-'}
                </h4>
                <div className="flex justify-between mt-2 text-xs text-gray-600 dark:text-gray-300"></div>
            </div>
            <div className="rounded-xl border border-gray-200 bg-white dark:border-gray-800 dark:bg-white/[0.03] md:p-5">
                <div className="flex items-center justify-center w-10 h-10 bg-gray-100 rounded-lg dark:bg-gray-800">
                    <FaWhatsapp className="text-gray-800 size-5 dark:text-white/90" />
                </div>

                <h4 className="mt-2 font-semibold text-gray-800 text-lg dark:text-white/90">
                    Whatsapp Shares: {data?.shares?.whatsappClicks ?? '-'}
                </h4>
                <div className="flex justify-between mt-2 text-xs text-gray-600 dark:text-gray-300"></div>
            </div>
            <div className="rounded-xl border border-gray-200 bg-white dark:border-gray-800 dark:bg-white/[0.03] md:p-5">
                <div className="flex items-center justify-center w-10 h-10 bg-gray-100 rounded-lg dark:bg-gray-800">
                    <MailIcon className="text-gray-800 size-5 dark:text-white/90" />
                </div>

                <h4 className="mt-2 font-semibold text-gray-800 text-lg dark:text-white/90">
                    Email Link: {data?.shares?.copyLinkClicks ?? '-'}
                </h4>
                <div className="flex justify-between mt-2 text-xs text-gray-600 dark:text-gray-300"></div>
            </div>
        </div>


    );
}
export default Cards;
